<template>
    <div
        class='dialog-box'
        v-show='show'
    >
        <transition name='isdialog'>
            <div>
                <div class="row content smooth-shadow">
                    <form class="col s12">
                        <div class="row">
                            <div class="input-field col s6">
                                <label v-if="type == 'option'">
                                    <input
                                        @click="type = 'option'"
                                        id="option1"
                                        checked
                                        class="with-gap"
                                        name="group1"
                                        type="radio"
                                    />
                                    <span><img
                                            class="iconFont"
                                            src="http://static.unicornselected.com/b0f9c100-0335-11eb-91c5-d550a48abe82.png"
                                        /> {{'期权'|language}} </span>
                                </label>
                                <label v-else>
                                    <input
                                        @click="type = 'option'"
                                        id="option2"
                                        class="with-gap"
                                        name="group1"
                                        type="radio"
                                    />
                                    <span><img
                                            class="iconFont"
                                            src="http://static.unicornselected.com/b0f9c100-0335-11eb-91c5-d550a48abe82.png"
                                        /> {{'期权'|language}}</span>
                                </label>
                            </div>
                            <div class="input-field col s6">
                                <label v-if="type == 'rsu'">
                                    <input
                                        checked
                                        @click="type = 'rsu'"
                                        id="rsu1"
                                        class="with-gap"
                                        name="group1"
                                        type="radio"
                                    />
                                    <span><img
                                            class="iconFont"
                                            src="http://static.unicornselected.com/b5beb600-838e-11e9-9b7a-bf944c367467.svg"
                                        /> {{'限售股'|language}}</span>
                                </label>
                                <label v-else>
                                    <input
                                        @click="type = 'rsu'"
                                        id="rsu2"
                                        class="with-gap"
                                        name="group1"
                                        type="radio"
                                    />
                                    <span><img
                                            class="iconFont"
                                            src="http://static.unicornselected.com/b5beb600-838e-11e9-9b7a-bf944c367467.svg"
                                        /> {{'限售股'|language}}</span>
                                </label>
                            </div>
                        </div>
                        <stock-input
                            :innerType="type"
                            @hasSubmited="submited"
                            ref="stockInput"
                        />
                    </form>
                </div>
                <div>
                    <a
                        class="waves-effect waves-light btn-large bgcolor"
                        @click="onSubmit"
                    >{{ en?(id == ''|| id == undefined ?'Add': 'Edit'):(id == ''|| id == undefined ?'确认添加': '确认修改')}}</a>
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    <a
                        class="waves-effect waves-light btn-large "
                        @click="close"
                    >{{'关闭'|language}}</a>
                </div>

            </div>

        </transition>
    </div>
</template>

<script>
import StockInput from '../stock/StockInput';
export default {
    name: 'StockAdd',
    components: {
        'stock-input': StockInput,
    },
    data() {
        return {
            show: true,
            type: 'option', // option期权，rsu限售股
            company: '',
            id: '',
        };
    },
    watch: {
        type(val) {
            this.$refs.stockInput.changeType(val);
        },
    },
    computed: {
        en() {
            return location.pathname.indexOf('/en') == -1 ? '' : '/en';
        },
    },
    mounted() {
        /*  console.log($('#date1').val()) 日期的值 */
        M.AutoInit();
        this.$refs.stockInput.init({
            type: this.type,
            company: this.company,
            id: this.id,
        });
    },
    methods: {
        onSubmit() {
            this.$refs.stockInput.onSubmit();
        },
        init(data) {
            this.company = data.company;
            this.type = data.type;
            this.id = data._id;
            this.$refs.stockInput.init({
                type: this.type,
                company: this.company,
                id: this.id,
            });
        },
        close() {
            this.type = 'option';
            this.$emit('closed', true);
        },
        submited(stock) {
            this.$emit('submited', stock);
        },
    },
};
</script>

<style lang="less" scoped>
.dialog-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}
.isdialog-enter-active,
.isdialog-leave-active {
    transition: all ease 0.5s;
}
.isdialog-enter,
.isdialog-leave-to {
    transform: scale(0);
    opacity: 0;
}
.content {
    height: 500px;
    width: 600px;
    background: white;
    transform-origin: 50% 50%;
    display: flex;
}
.bgcolor {
    background: #ba2730;
}
</style>
